import React from "react";

import { apiCall } from '@app/utils/apiCall';
import { useAuth } from '@app/contexts/AuthContext';
import { useDossier } from "@app/contexts/DossierContext";
import ButtonPrimary from "@app/components/1_elements/ButtonPrimary";
import ButtonSecondary from "@app/components/1_elements/ButtonSecondary";
import { downloadFile } from "@app/utils/util";

export default function SectionDownload() {
    const dossier = useDossier();
    const auth = useAuth();
    
    function downloadCerfa(cerfaType) {
        let formData = new FormData;
        formData.append("cerfa_type", cerfaType)
        formData.append("dossier_id", dossier.id)
        
        /** One file per structure must be downloaded - specific rule */
        if (cerfaType == "Consumption") {
            for (let i=0; i < dossier.structure_datas.length; i++) {
                formData.append("structure_id", dossier.structure_datas[i].structure.id)
                launchDownload(formData);
            }
        } else {            
            formData.append("structure_id", dossier.structure_datas[0].structure.id)
            launchDownload(formData);
        }            
    }

    function launchDownload(formData) {
        apiCall({
            method: "post",
            path: "/api/v1/cerfa/download",
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                const data = response.data;
                downloadFile(data.file, data.filetype, data.filename);
            }
        })
    }

    function downloadReport(event, type) {
        event.preventDefault();
        
        const formData = new FormData();

        formData.append("generated_document[dossier_id]", dossier.id);
        formData.append("generated_document[name]", type);
        formData.append("generated_document[doc_type]", type);

        apiCall ({
            method: "post",
            path: `/api/v1/generated_documents`,
            auth: auth,
            data: formData,
            onSuccess: (response) => {
                const file = response.data.generated_document.file;
                const link = document.createElement('a');

                link.href = file.url;
                link.download = file.filename;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        });  
    }

    return (
        <div>
            <div className="row">
                <div className="col-2">
                    <ButtonPrimary 
                        label="VA" 
                        onClick={() => downloadCerfa("AddedValue")}
                        customClass="w-100"
                    />
                </div>
                <div className="col-2">
                    <ButtonSecondary 
                        label="Récap. conso." 
                        onClick={() => downloadCerfa("Consumption")}
                        customClass="w-100"
                    />
                </div>
                <div className="col-2">
                    <ButtonSecondary 
                        label="Décl. régul." 
                        onClick={() => downloadCerfa("Regul")}
                        customClass="w-100"
                    />
                </div>
                <div className="col-2">
                    <ButtonSecondary 
                        label="Rapport" 
                        onClick={(event) => downloadReport(event, "hoh_report_final")}
                        customClass="w-100"
                    />
                </div>
            </div>
        </div>
    )
}